import { ReactElement } from 'react';
import {
  FeedbackNotification as ToqioFeedbackNotification,
  FeedbackNotificationProps,
  FEEDBACK_VARIANTS,
} from '@toqio/toqio-web-components';

import { VariantFeedbackNotificationProps } from './feedback-notification.types';

/**
 * TOQIO FEEDBACKNOTIFICATION - no exportable
 * use specific components for different variants instead
 */
const FeedbackNotification = ({
  variant,
  title,
  message,
  hasCloseIcon,
  onClose,
  rightActions,
  bottomActions,
  customContent,
  className,
  style,
}: FeedbackNotificationProps): ReactElement => {
  return (
    <ToqioFeedbackNotification
      variant={variant}
      title={title}
      message={message}
      hasCloseIcon={hasCloseIcon}
      onClose={onClose}
      rightActions={rightActions}
      bottomActions={bottomActions}
      customContent={customContent}
      className={className}
      style={style}
    />
  );
};

export const FeedbackNotificationError = (props: VariantFeedbackNotificationProps): ReactElement => {
  return <FeedbackNotification {...props} variant={FEEDBACK_VARIANTS.ERROR} />;
};

export const FeedbackNotificationSuccess = (props: VariantFeedbackNotificationProps): ReactElement => {
  return <FeedbackNotification {...props} variant={FEEDBACK_VARIANTS.SUCCESS} />;
};

export const FeedbackNotificationWarning = (props: VariantFeedbackNotificationProps): ReactElement => {
  return <FeedbackNotification {...props} variant={FEEDBACK_VARIANTS.WARNING} />;
};

export const FeedbackNotificationInfo = (props: VariantFeedbackNotificationProps): ReactElement => {
  return <FeedbackNotification {...props} variant={FEEDBACK_VARIANTS.INFO} />;
};
